import { render, staticRenderFns } from "./create-your-own-scene.vue?vue&type=template&id=d4d45596&"
import script from "./create-your-own-scene.vue?vue&type=script&lang=js&"
export * from "./create-your-own-scene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports